<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface NoSearchResultsProps {
  title?: string
  message?: string
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { Button } from '#ui-kit/ui/button'
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '#ui-kit/ui/empty'

const props = withDefaults(defineProps<NoSearchResultsProps>(), {
  title: 'No results found',
  message: 'Try adjusting your search or filters.',
})

const emit = defineEmits<{
  clear: []
}>()
</script>

<template>
  <Empty :class="props.class">
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <MagnifyingGlassIcon aria-hidden="true" />
      </EmptyMedia>

      <EmptyTitle>{{ title }}</EmptyTitle>

      <EmptyDescription v-if="message">{{ message }}</EmptyDescription>
    </EmptyHeader>

    <EmptyContent>
      <Button size="sm" @click="emit('clear')">Clear <XMarkIcon /></Button>
    </EmptyContent>
  </Empty>
</template>
